import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Login } from '../models/login';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JwtAuth } from '../models/jwtAuth';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  loginUrl = "auth/login";

  constructor(private http: HttpClient) { }

  public login(user: Login): Observable<JwtAuth> {
    return this.http.post<JwtAuth>(`core/api/${this.loginUrl}`, user)
  }
}
